import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";
import store from "@/store";
import globals from "@/globals";

// Layouts
import Layout from "@/layout/Layout";
import CustomLayout from "@/layout/CustomLayout";

Vue.use(Router);
Vue.use(Meta);

var routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/pages/Index")
      }
    ],
    path: "/PageDisabled",
    component: () => import("@/pages/PageDisabled")
  },
  {
    path: "/:companyName",
    component: CustomLayout,
    children: [
      {
        path: "QueueStatus",
        component: () => import("@/pages/QueueStatus")
      },
      {
        path: "Reservation",
        component: () => import("@/pages/Reservation")
      },
      {
        path: "Info/:reservationId/:action?",
        component: () => import("@/pages/ReservationStatus")
      },
      {
        path: "",
        component: () => import("@/pages/Reservation")
      }
    ]
  }
];

const router = new Router({
  base: "/",
  mode: "history",
  routes
});

function guardRoute(to, from, next) {
  if (store.getters.isLoggedIn) {
    if (to.path == "/login" || to.path == "/register") {
      next({
        path: "/"
      });
    }
    next();
  }
  if (!store.getters.isLoggedIn) {
    if (to.path == "/login" || to.path == "/register") {
      next();
    } else {
      if (to.fullPath != "/") store.state.redirect = to.fullPath;
      next({
        path: "/login"
      });
    }
  }
  next();
}

router.afterEach(() => {
  // On small screens collapse sidenav
  if (
    window.layoutHelpers &&
    window.layoutHelpers.isSmallScreen() &&
    !window.layoutHelpers.isCollapsed()
  ) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10);
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0);
});

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add("app-loading");

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10);
});

export default router;
